<template>

</template>
<script>
export default {
  data() {
    return {}
  }
}
</script>

<style lang='less'>
</style>



// WEBPACK FOOTER //
// FAQ.vue?3c4c71ee